// Session storage key used to carry the UID of an event that should be opened
// once the user lands on the calendar page (e.g. when following a /events/:uid
// deep link that first has to go through the authentication flow).
export const PENDING_EVENT_UID_KEY = 'pendingEventUid'
